// extracted by mini-css-extract-plugin
export default {"jupyter-icon":"WorkflowActionsPopup_jupyter-icon__VXLu8"};